module.exports = __webpack_public_path__ + "img/new.2be0ef65.svg";